<template>
  <b-list-group>
    <b-list-group-item>
      <div class="font-weight-bold text-primary">
        Puan Ortalaması
      </div>
      <div>
        <b-form-rating
          no-border
          class="bg-transparent"
          variant="warning"
          :value="dataItem.rating_avg"
          size="lg"
          readonly
        />
      </div>
    </b-list-group-item>
    <b-list-group-item>
      <div class="font-weight-bold text-primary">
        Lezzet
      </div>
      <div>
        <b-form-rating
          no-border
          class="bg-transparent"
          variant="warning"
          :value="dataItem.flavor_rating"
          size="sm"
          readonly
        />
      </div>
    </b-list-group-item>
    <b-list-group-item>
      <div class="font-weight-bold text-primary">
        Hizmet
      </div>
      <div>
        <b-form-rating
          no-border
          class="bg-transparent"
          variant="warning"
          :value="dataItem.service_rating"
          size="sm"
          readonly
        />
      </div>
    </b-list-group-item>
    <b-list-group-item>
      <div class="font-weight-bold text-primary">
        Menü İçeriği
      </div>
      <div>
        <b-form-rating
          no-border
          class="bg-transparent"
          variant="warning"
          :value="dataItem.menu_content_rating"
          size="sm"
          readonly
        />
      </div>
    </b-list-group-item>
    <b-list-group-item>
      <div class="font-weight-bold text-primary">
        Ortam
      </div>
      <div>
        <b-form-rating
          no-border
          class="bg-transparent"
          variant="warning"
          :value="dataItem.environment_rating"
          size="sm"
          readonly
        />
      </div>
    </b-list-group-item>
    <b-list-group-item>
      <div class="font-weight-bold text-primary">
        Fiyatlandırma
      </div>
      <div>
        <b-form-rating
          no-border
          class="bg-transparent"
          variant="warning"
          :value="dataItem.price_rating"
          size="sm"
          readonly
        />
      </div>
    </b-list-group-item>
  </b-list-group>
</template>
<script>
import { BFormRating, BListGroup, BListGroupItem } from 'bootstrap-vue'

export default {
  name: 'RatingCard',
  components: { BFormRating, BListGroup, BListGroupItem },
  props: {
    dataItem: {
      type: Object,
      required: true,
    },
  },
}
</script>
